var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "448px",
    height: "512px",
    viewBox: "0 0 448 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tiktok") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tiktok",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448,209.91 C403.974707,210.015307 361.029083,196.28544 325.23,170.66 L325.23,349.38 C325.20511,417.162851 283.121532,477.814896 219.635835,501.565301 C156.150137,525.315706 84.5908745,507.178175 40.0826479,456.055447 C-4.42557868,404.93272 -12.5384556,331.557796 19.726193,271.946489 C51.9908417,212.335182 117.85919,179.002632 185,188.31 L185,278.2 C154.223779,268.519426 120.711625,279.71419 101.932853,305.948653 C83.1540818,332.183116 83.3621885,367.515027 102.448691,393.526461 C121.535193,419.537896 155.176893,430.337121 185.836945,420.294684 C216.496996,410.252247 237.230729,381.642816 237.23,349.38 L237.23,0 L325.23,0 C325.168874,7.43140026 325.791498,14.8526687 327.09,22.17 L327.09,22.17 C333.270126,55.1831654 352.767811,84.1964147 381,102.39 C400.873895,115.530921 424.174479,122.535007 448,122.53 L448,209.91 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokBlack);
export default __webpack_public_path__ + "static/media/tiktok--black.3db22fb084085cc0d6623b92a7f53b9c.svg";
export { ForwardRef as ReactComponent };